export enum EIntegrationTypes {
  IntegracaoVeiculo = 1
}
